import { render, staticRenderFns } from "./popupList.vue?vue&type=template&id=204c9ad4&scoped=true"
import script from "./popupList.vue?vue&type=script&lang=js"
export * from "./popupList.vue?vue&type=script&lang=js"
import style0 from "./popupList.vue?vue&type=style&index=0&id=204c9ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c9ad4",
  null
  
)

export default component.exports